import { render, staticRenderFns } from "./StockProductInOut.vue?vue&type=template&id=d1050fec&"
import script from "./StockProductInOut.vue?vue&type=script&lang=js&"
export * from "./StockProductInOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports